import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import getPlan from '../apollo/graphql/plan/get';
import updatePlan from '../apollo/graphql/plan/update';
import { languages } from '../constants';
import PlanForm from '../components/form/Plan';

class PlanContainer extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
      },
      redirect: false,
      obj: {
        google_maps_url: '',
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  fetchPlan() {
    this.props.client
      .query({
        query: getPlan,
      })
      .then(({ data }) => {
        if (getPlan.error) {
          this.setState({
            status: {
              ...this.state.status,
              error: true,
              message: getPlan.error.message,
            },
          });
        }

        const newObject = {
          ...this.state.obj,
          ...data.getPlan,
        };
        this.setState({
          ...this.state,
          status: {
            ...this.state.status,
            loading: false,
          },
          obj: {
            ...this.state.obj,
            ...newObject,
          },
        });
      });
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    this.fetchPlan();
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }

    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (type === 'dropdown') {
      //dropdown
      newState.obj[data.id] = data.value;
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = this.state.obj;

    // update object
    let newObj = {
      ...obj,
    };
    delete newObj.id;
    this.props
      .updatePlan({
        variables: { ...newObj },
      })
      .then(({ data, errors }) => {
        if (errors) {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              errors: errors,
            },
          });
        } else {
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
              messages: [{ message: 'Sauvegarde effectuée' }],
            },
          });
          this.fetchPlan();
        }
      });
  }

  render() {
    if (this.state.status.loading) {
      return <div>Chargement</div>;
    }
    return (
      <PlanForm
        obj={this.state.obj}
        status={this.state.status}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const PlanContainerEnhanced = compose(
  graphql(updatePlan, { name: 'updatePlan' }),
)(PlanContainer);

export default withApollo(PlanContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/PlanContainer.js